import * as types from "../../../actions/systemlevel/index";

export default function(state = [], action) {
  switch (action.type) {
    case types.ZIP_CODE:
      return action.payload.data;
    default:
      return state;
  }
}
